import { render, staticRenderFns } from "./InfinityChallengesTab.vue?vue&type=template&id=75e2e5f1&scoped=true&"
import script from "./InfinityChallengesTab.vue?vue&type=script&lang=js&"
export * from "./InfinityChallengesTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75e2e5f1",
  null
  
)

export default component.exports